module.exports = __webpack_public_path__ + "img/completedacourse_WBT_white.4ff11ce6.svg";